// Median of a numeric list. Empty list returns 0 (callers gate on length
// before treating the result as meaningful). Even-length lists average the two
// middle values. Does not mutate the input. Shared by the Rhythm and Work-weeks
// panels, which both summarise per-day / per-week values by their median rather
// than mean so a single outlier day/week doesn't skew the typical figure.
export function median(values: number[]): number {
  if (values.length === 0) return 0;
  const sorted = [...values].sort((a, b) => a - b);
  const mid = Math.floor(sorted.length / 2);
  return sorted.length % 2 === 0
    ? (sorted[mid - 1] + sorted[mid]) / 2
    : sorted[mid];
}
